module.exports = __webpack_public_path__ + "img/wastmanagement.a26eaa3d.jpg";